import { FC } from 'react';
import { Box, Skeleton } from '@mui/material';

export const SkeletonForm: FC = () => {
  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Skeleton variant="text" width={200} height={32} />
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 2 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Skeleton variant="text" width={120} height={20} />
          <Skeleton variant="rectangular" height={40} />
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Skeleton variant="text" width={120} height={20} />
          <Skeleton variant="rectangular" height={40} />
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Skeleton variant="text" width={120} height={20} />
          <Skeleton variant="rectangular" height={40} />
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Skeleton variant="text" width={120} height={20} />
          <Skeleton variant="rectangular" height={40} />
        </Box>
      </Box>
      <Skeleton variant="text" width={200} height={32} sx={{ mt: 2 }} />
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 2 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Skeleton variant="text" width={120} height={20} />
          <Skeleton variant="rectangular" height={40} />
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Skeleton variant="text" width={120} height={20} />
          <Skeleton variant="rectangular" height={40} />
        </Box>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2 }}>
        <Skeleton variant="rectangular" width={100} height={36} />
        <Skeleton variant="rectangular" width={100} height={36} />
      </Box>
    </Box>
  );
};

export default SkeletonForm;
